import React, { useState } from "react";
import { Card, Typography, Box, Avatar, Grid, Tooltip } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";

const DoctorsInfoCard = ({ doctor, selected, handleViewAppointment }) => {
  // const [isSelected, setIsSelected] = useState(false);

  const formatTime = (timeString) => {
    if (!timeString) return "-";
    const [hours, minutes] = timeString.split(":");
    let period = "AM";
    let formattedHours = parseInt(hours, 10);
    if (formattedHours >= 12) {
      if (formattedHours > 12) formattedHours -= 12;
      period = "PM";
    }
    return `${formattedHours}:${minutes} ${period}`;
  };

  const formatExperience = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (Number.isNaN(num)) return value;

    const totalMonths = Math.round(num * 12);
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    const yearLabel = years === 1 ? "yr" : "yrs";
    const monthLabel = months === 1 ? "mo" : "mos";

    return `${years} ${yearLabel} ${months} ${monthLabel}`;
  };

  const shouldShowExperience = (value) => {
    if (value === null || value === undefined || value === "") return false;
    const num = Number(value);
    if (Number.isNaN(num)) return true;
    return num > 0;
  };

  const getGenderString = (gender) => {
    if (gender === "male") return "Male";
    if (gender === "female") return "Female";
    return "-";
  };

  // const handleCardClick = () => {
  //   setIsSelected(!isSelected);
  //   handleViewAppointment(doctor);
  // };

  const handleCardClick = () => {
    handleViewAppointment(doctor);
  };

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: { xs: 1.5, sm: 2 },
        marginBottom: { xs: 1, sm: 2 },
        height: { xs: 140, sm: 170 },
        borderRadius: "10px",
        border: selected ? "2px solid #21cdc0" : "1px solid #21cdc0",
        boxShadow: selected
          ? "0 4px 12px rgba(0, 0, 0, 0.14)"
          : "0 2px 6px rgba(0, 0, 0, 0.08)",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        backgroundColor: "#EBFAF9",
        "&:hover": {
          // boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
          borderColor: "#21cdc0",
        },
      }}
    >
      <Grid container spacing={{ xs: 1, sm: 2 }} alignItems="center">
        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            <Avatar
              alt={doctor?.name || "Doctor"}
              src={doctor?.photo || ""}
              sx={{ 
                width: { xs: 50, sm: 60 }, 
                height: { xs: 50, sm: 60 }, 
                marginRight: { xs: 1.5, sm: 2 }, 
                mt: { xs: -2, sm: -4 } 
              }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: 600,
                  lineHeight: 1.2,
                  mb: 0.5
                }}
              >
                {doctor?.salutation ? `${doctor.salutation} ` : ""}
                {doctor?.name || "-"}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ 
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  lineHeight: 1.2,
                  mb: 0.5
                }}
              >
                {getGenderString(doctor?.gender)}
                {shouldShowExperience(doctor?.years_of_experience) ? (
                  <>
                    , {formatExperience(doctor.years_of_experience)} experience
                  </>
                ) : null}
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ 
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  lineHeight: 1.2,
                  mb: 1
                }}
              >
                {doctor?.specialization || "-"}
              </Typography>

              {/* Icons just below the above text */}
              <Box 
                display="flex" 
                gap={{ xs: 1, sm: 2 }} 
                mt={{ xs: 1, sm: 2 }}
                flexWrap="wrap"
              >
                <Tooltip
                  title={
                    doctor?.city
                      ? `${doctor.city}, ${doctor.state || ""}`
                      : doctor?.state || "-"
                  }
                  arrow
                >
                  <LocationOnIcon
                    sx={{ 
                      color: "#21cdc0", 
                      cursor: "pointer",
                      fontSize: { xs: "1rem", sm: "1.25rem" }
                    }}
                  />
                </Tooltip>

                <Tooltip title={doctor?.phone_no || "-"} arrow>
                  <PhoneIcon
                    sx={{ 
                      color: "#21cdc0", 
                      cursor: "pointer",
                      fontSize: { xs: "1rem", sm: "1.25rem" }
                    }}
                  />
                </Tooltip>

                <Tooltip title={doctor?.email || "-"} arrow>
                  <MailIcon
                    sx={{ 
                      color: "#21cdc0", 
                      cursor: "pointer",
                      fontSize: { xs: "1rem", sm: "1.25rem" }
                    }}
                  />
                </Tooltip>

                <Tooltip
                  title={
                    doctor?.availability_start && doctor?.availability_end
                      ? `${formatTime(
                          doctor.availability_start
                        )} - ${formatTime(doctor.availability_end)}`
                      : "-"
                  }
                  arrow
                >
                  <AccessTimeIcon
                    sx={{ 
                      color: "#21cdc0", 
                      cursor: "pointer",
                      fontSize: { xs: "1rem", sm: "1.25rem" }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      alert("Availability clicked");
                    }}
                  />
                </Tooltip>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default DoctorsInfoCard;
